import * as React from 'react';
import { Link } from 'react-router';
import { commonStingManagerManager } from '../../api/commonStingManagerManager';

import Pagination from "react-js-pagination";

import EventItemDto from '../../api/eventItemDto';
import EventItem from '../../api/eventItemEntity';
import NewsCategory from '../../api/newsCategoryEntity';

import { BreadcrumbContainer } from '../../common/components/breadcrumb/breadcrumbContainer';

interface IProps {
    categoriesFilter: string;
    newsCategories: NewsCategory[];
    eventItemDto: EventItemDto;
    fetchArchiveEventItems(query?: object): void;
    fetchArchiveEventItemsByCategory(categories: string, query?: object): void;
    fetchEventCategories(): void;
}

export class EventsArchivePage extends React.Component<IProps,{itemsOnPage: number, isItemsRecieved: boolean}> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            isItemsRecieved: false,
            itemsOnPage: 10
        };

        this.handlePageChange = this.handlePageChange.bind(this);
    }

  public componentDidMount() {
    this.props.fetchEventCategories();
  }

  public componentWillReceiveProps (nextProps: IProps) {
    if(nextProps.categoriesFilter !== this.props.categoriesFilter || !this.state.isItemsRecieved) {
        if (nextProps.newsCategories.length !== 0 && !this.state.isItemsRecieved) {
            this.setState({
                isItemsRecieved: true
            })
        }

        if (!nextProps.categoriesFilter) {
            this.props.fetchArchiveEventItems({limit: this.state.itemsOnPage});
            return;
        }

        const propertyToEquel = "/" + nextProps.categoriesFilter;

        nextProps.newsCategories.forEach(element => {
            if (propertyToEquel === element.friendlyUrl) {
                this.props.fetchArchiveEventItemsByCategory(element.id, {limit: this.state.itemsOnPage});
                return;
            }
        });
    }
 }

 public handlePageChange = (pageNumber: number) => {
    const skipItems = this.state.itemsOnPage * pageNumber - this.state.itemsOnPage;

    if(this.props.categoriesFilter) {
        const propertyToEquel = "/" + this.props.categoriesFilter;

        this.props.newsCategories.forEach(element => {
            if (propertyToEquel === element.friendlyUrl) {
                this.props.fetchArchiveEventItemsByCategory(element.id, {limit: this.state.itemsOnPage, skip: skipItems});
                return;
            }
        });
        
    } else {
        this.props.fetchArchiveEventItems({limit: this.state.itemsOnPage, skip: skipItems});
    }
}

  public render() {
    let cssClassName = "";

      if (window.location.href.indexOf("ajankohtaista/") === -1) {
          cssClassName = "active";
      }
      
    return (
        <main className="contentpage">
            <div className="container">

                <BreadcrumbContainer />

                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <h1>Kaikki tapahtumat</h1>
                        <div className="categories">
                            <b>Suodata aiheen mukaan</b>
                            <div className="categories-list">
                                <ul id="taglist">
                                    <li><Link className={cssClassName} to={"/tapahtumat/ajankohtaista"}>Kaikki</Link></li>
                                    {this.props.newsCategories && this.props.newsCategories.map(NewsCategoryItem)}
                                </ul>
                            </div>
                        </div>
                        <ul className="newslisting">
                        {this.props.eventItemDto.eventItems.map(ArchiveNewsItem)}
                        </ul>
                        <Pagination
                            activePage={this.props.eventItemDto.skip / this.state.itemsOnPage + 1}
                            itemsCountPerPage={this.props.eventItemDto.limit}
                            totalItemsCount={this.props.eventItemDto.total}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange}
                            />
                    </div>
                </div>
            </div>
        </main>
    );
  }
};

const ArchiveNewsItem = (evetItem: EventItem) => {
    return (
        <li>
            <span className="event-info">
                <span className="date">{commonStingManagerManager.formatDateToFiCulture(evetItem.eventDate)}</span>
                <span className="organiser">{evetItem.eventPlace.title}</span>
            </span>
            <Link to={`/tapahtumat${evetItem.id}`} >{evetItem.title}</Link>
        </li>
    )
  }

  const NewsCategoryItem = (newsCategory: NewsCategory) => {
    let cssClassName = "";

    if (window.location.href.indexOf(newsCategory.friendlyUrl) !== -1) {
        cssClassName = "active";
    }

    return (
      <li>
        <Link className={cssClassName} to={`/tapahtumat/ajankohtaista${newsCategory.friendlyUrl}`}>{newsCategory.title}</Link>
      </li>
    )
  }


// WEBPACK FOOTER //
// ./src/components/eventsArchivePage/eventsArchivePage.tsx